export default "__VITE_ASSET__aedf1efb__"